import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { ValidatePromotionCodePayload } from 'Interfaces/Billing';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: ValidatePromotionCodePayload) =>
    $actions.billing.validatePromotionCode(dispatch, payload),
  );
};
